export const hooksActions = {
    GET_HOOKS_MODELS: 'GET_HOOKS_MODELS',
    SET_HOOKS_MODELS: 'SET_HOOKS_MODELS',
    GET_ACTION_MODELS: 'GET_ACTION_MODELS',
    SET_ACTION_MODELS: 'SET_ACTION_MODELS',
    GET_HOOKS_EVENTS_AND_STEPS: 'GET_HOOKS_EVENTS_AND_STEPS',
    SET_HOOKS_EVENTS_AND_STEPS: 'SET_HOOKS_EVENTS_AND_STEPS',
    GET_HOOK_PARAMETERS: 'GET_HOOK_PARAMETERS',
    SET_HOOK_PARAMETERS: 'SET_HOOK_PARAMETERS',
    SAVE_HOOK: 'SAVE_HOOK',
    DELETE_HOOK: 'DELETE_HOOK'
};

const initState = {
    hookModels: [],
    hookAction: [],
    hookEventSteps: {}
};

export const hooksReducer = (state = initState, action: any) => {
    switch (action.type) {
        case hooksActions.SET_HOOKS_MODELS:
            return Object.assign({}, state, { hooksModel: action.payload });

        case hooksActions.SET_ACTION_MODELS:
            return Object.assign({}, state, { hookAction: action.payload });

        case hooksActions.SET_HOOKS_EVENTS_AND_STEPS:
            return Object.assign({}, state, { hookEventSteps: action.payload });

        case hooksActions.SET_HOOK_PARAMETERS:
            return Object.assign({}, state, action.payload);

        case hooksActions.SAVE_HOOK:
            return Object.assign({}, state, { currentHook: action.payload });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/hooksReducer.ts